import { createSlice, current } from "@reduxjs/toolkit";

export const updateQuerySlice = createSlice({
    name: "query",
    initialState: { query: undefined },
    reducers: {
        setQuery: (state, action) => {
            state = action.payload;
            return state;
        },
        addCondition: (state, action) => {
            const [query, ...positionKey] = action.payload;
            if (positionKey.length === 1) {
                state.query.conditions.push(query);
            } else {
                const clause = findConditionsWithIndex(state, positionKey);
                clause.push(query);
            }
        },
        addSubclause: (state, action) => {
            const [subclause, ...positionKey] = action.payload;
            if (positionKey.length === 1) {
                state.query.conditions.push(subclause);
            } else {
                const clause = findConditionsWithIndex(state, positionKey);
                clause.push(subclause);
            }
        },
        removeCondition: (state, action) => {
            const indexArr = action.payload;
            const i = indexArr.pop();
            const clause = findConditionsWithIndex(state, indexArr);
            // if last item in subclause
            if (clause.length === 1) {
                const i = indexArr.pop();
                const clause = findConditionsWithIndex(state, indexArr);
                clause.splice(i, 1);
            } else {
                clause.splice(i, 1);
            }
        },
        updateArea: (state, action) => {
            state.mapArea = action.payload;
        },
        updateLogicOperator: (state, action) => {
            const [newOperator, ...positionKey] = action.payload;
            if (positionKey.length === 1) {
                state.query.logicOperator = newOperator;
            } else {
                const clause = findClauseWithIndex(state, positionKey);
                clause.logicOperator = newOperator;
            }
        },
        updateField: (state, action) => {
            const [newField, ...positionKey] = action.payload;
            const condition = findConditionWithIndex(state, ...positionKey);
            condition.field = newField;
        },
        updateOperator: (state, action) => {
            const [newOperator, ...positionKey] = action.payload;
            const condition = findConditionWithIndex(state, ...positionKey);
            condition.operator = newOperator;
        },
        updateValue: (state, action) => {
            const [newValue, ...positionKey] = action.payload;
            const condition = findConditionWithIndex(state, ...positionKey);
            condition.value = newValue;
        },
    },
});

export const {
    setQuery,
    addCondition,
    addSubclause,
    removeCondition,
    updateArea,
    updateLogicOperator,
    updateField,
    updateOperator,
    updateValue,
} = updateQuerySlice.actions;
export default updateQuerySlice.reducer;

/* 
Returns array of conditions
[
  {
    field: ddData[0],
    operator: stringOperators[0],
    value: "",
  },
  {
    field: ddData[0],
    operator: stringOperators[0],
    value: "",
  },
]
*/
const findConditionsWithIndex = (state, indexArr) => {
    let conditions = state.query.conditions;
    for (let i = 1; i < indexArr.length; i++) {
        conditions = conditions[indexArr[i]].conditions;
    }
    return conditions;
};

/*
Returns condition object
{
  field: ddData[0],
  operator: stringOperators[0],
  value: "",
}
*/
const findConditionWithIndex = (state, indexArr) => {
    const i = indexArr.pop();
    const conditions = findConditionsWithIndex(state, indexArr);
    const condition = conditions[i];
    return condition;
};

/*
Returns clause object
  {
    logicOperator: "AND",
    conditions: [
      {
        field: ddData[0],
        operator: stringOperators[0],
        value: "",
      },
      {
        field: ddData[0],
        operator: stringOperators[0],
        value: "",
      },
    ],
  },
*/
const findClauseWithIndex = (state, indexArr) => {
    let clause;
    let conditions = state.query.conditions;
    for (let i = 1; i < indexArr.length; i++) {
        if (i < indexArr.length) {
            clause = conditions[indexArr[i]];
        }
        conditions = conditions[indexArr[i]].conditions;
    }
    return clause;
};

/* 
Example of query with subclause:

{
  dataSource: dataSource,
  mapArea: "All",
  query: {
    logicOperator: "AND",
    conditions: [
      {
        field: ddData[0],
        operator: stringOperators[0],
        value: "",
      },
      {
        field: ddData[0],
        operator: stringOperators[0],
        value: "",
      },
      {
        logicOperator: "AND",
        conditions: [
          {
            field: ddData[0],
            operator: stringOperators[0],
            value: "",
          },
          {
            field: ddData[0],
            operator: stringOperators[0],
            value: "",
          },
        ],
      },
    ],
  },
};
*/
